
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faucet",
      function () {
        return require("private-next-pages/faucet.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faucet"])
      });
    }
  